<patron-modal
  cancelButtonText="Cancelar"
  confirmButtonText="Atualizar"
  [visible]="visible"
  (confirm)="runBulkUpdate()"
  (cancel)="close()"
  [headerTemplate]="headerTemplate"
  customClass="task-bulk-update-modal">
  <ng-template #headerTemplate>
    <h4 class="titleTaskBulk">Atualização em massa</h4>
    <div class="titleTaskBulkButton">
      <patron-button
        variant="ghost"
        iconName="bi bi-x-lg"
        color="secondary"
        (click)="close()"></patron-button>
    </div>
  </ng-template>

  <div class="bulk-update-container">
    <!-- ============================
         SEÇÃO: Seleção de Tarefas
         ============================ -->
    <div class="bulk-section">
      <div class="bulk-section-header">
        <span class="bulk-section-title">
          <i class="pi pi-list"></i>
          Tarefas para atualizar
        </span>
        <div class="bulk-select-all-row">
          <span class="bulk-selected-count">
            {{ selectedCount }} de {{ tasks.length }} selecionada(s)
          </span>
          <patron-button
            variant="ghost"
            [color]="allSelected ? 'secondary' : 'primary'"
            (click)="toggleSelectAll()">
            {{ allSelected ? 'Desmarcar todas' : 'Marcar todas' }}
          </patron-button>
        </div>
      </div>

      <div class="bulk-tasks-list">
        @for (task of tasks; track task.id) {
          <div
            class="bulk-task-card"
            [class.bulk-task-card--selected]="isSelected(task.id)"
            (click)="toggleTaskSelection(task.id)">
            <div class="bulk-task-check">
              <input type="checkbox" [checked]="isSelected(task.id)" />
            </div>

            <div class="bulk-task-info">
              <!-- Linha 1: seq + label -->
              <div class="bulk-task-top-row">
                <span class="bulk-task-seq">#{{ task.sequence }}</span>
                <span class="bulk-task-summary" [title]="getTaskLabel(task)">{{
                  getTaskLabel(task)
                }}</span>
              </div>

              <!-- Linha 2: dificuldade + status -->
              <div class="bulk-task-meta-row">
                @if (task.difficulty) {
                  <span
                    class="badge"
                    [class.alert-success]="task?.difficulty === 'F'"
                    [class.alert-primary]="task?.difficulty === 'M'"
                    [class.alert-danger]="task?.difficulty === 'D'"
                    >{{ task?.difficulty | difficulty }}</span
                  >
                }
                @if (task.status?.description) {
                  <patron-badge [color]="getStatusClass(task?.status?.description)">
                    {{ task.status?.description }}
                  </patron-badge>
                }
              </div>

              <!-- Linha 3: dev, pontos, data, conclusão -->
              <div class="bulk-task-meta-row">
                @if (task.user?.name) {
                  <span class="bulk-task-meta-item">
                    <i class="pi pi-user"></i> {{ task.user?.name }}
                  </span>
                }
                @if (task.estimated_effort) {
                  <span class="bulk-task-meta-item">
                    <i class="pi pi-bolt"></i> {{ task.estimated_effort }} pt
                  </span>
                }
                @if (task.expected_date) {
                  <span class="bulk-task-meta-item">
                    <i class="pi pi-calendar"></i>
                    {{ task.expected_date | date: 'dd/MM/yyyy' }}
                  </span>
                }
                @if (task.finished) {
                  <span class="bulk-task-badge-finished">
                    <i class="pi pi-check-circle"></i> Concluída
                  </span>
                }
              </div>
            </div>
          </div>
        }
        @if (!tasks.length) {
          <div class="bulk-tasks-empty">Nenhuma tarefa disponível</div>
        }
      </div>
    </div>

    <!-- ============================
         SEÇÃO: Campos de Atualização
         ============================ -->
    <div class="bulk-section bulk-section--fields">
      <span class="bulk-section-title">
        <i class="pi pi-pencil"></i>
        Dados a atualizar
      </span>
      <patron-form [formGroup]="formGroup" novalidate>
        <div class="form-group row">
          <div class="col taskBulkModal">
            <patron-select
              [formGroup]="formGroup"
              formControlName="status"
              orderBy="ref"
              placeholder="Status"
              bindLabel="description"
              label="Status"
              modelName="ticket-statuses">
            </patron-select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col taskBulkModal">
            <patron-select
              [formGroup]="formGroup"
              formControlName="developer"
              placeholder="Desenvolvedor"
              bindLabel="_name"
              orderBy="ref"
              label="Desenvolvedor"
              modelName="users">
            </patron-select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col taskBulkModal">
            <patron-form-field
              type="date"
              formControlName="expectedDateString"
              [formGroup]="formGroup"
              placeholder="Previsão"
              label="Previsão">
            </patron-form-field>
          </div>
        </div>
        <div class="form-group row">
          <div class="col taskBulkModal">
            <patron-form-check [inputTemplate]="removeDateInput" [labelTemplate]="removeDateLabel">
              <ng-template #removeDateInput>
                <input
                  type="checkbox"
                  id="removeExpectedDate"
                  formControlName="removeExpectedDate"
                  (change)="onRemoveExpectedDateChange()" />
              </ng-template>
              <ng-template #removeDateLabel>
                <label for="removeExpectedDate">Remover data previsão</label>
              </ng-template>
            </patron-form-check>
          </div>
        </div>
        <div class="my-5 py-5">
          <!--Oi eu estou aqui para preencher um espaço em branco embaixo dos selects, pois se não as opções do dropdown não cabem dentro do modal-->
        </div>
      </patron-form>
    </div>
  </div>

  <patron-modal
    title="Atualização em massa"
    cancelButtonText="Cancelar"
    confirmButtonText="Confirmar"
    [visible]="visibleConfirm"
    (confirm)="_confirm()">
    <p>Tem certeza de que deseja alterar</p>
    <p>{{ this.messageArrayToString(msgs!) }}</p>
    <p>
      nas <strong>{{ selectedCount }}</strong> tarefa(s) selecionada(s)?
    </p>
  </patron-modal>
</patron-modal>

<style>
  .bulk-update-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.25rem 0;
  }

  .bulk-section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .bulk-section--fields {
    border-top: 1px solid var(--p-surface-200, #e2e8f0);
    padding-top: 0.85rem;
  }

  .bulk-section-header {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

  .bulk-section-title {
    font-weight: 700;
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--p-text-secondary-color, #6b7280);
    display: flex;
    align-items: center;
    gap: 0.35rem;
  }

  .bulk-select-all-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .bulk-selected-count {
    font-size: 0.78rem;
    font-weight: 600;
    color: var(--p-primary-600, #2563eb);
    background: color-mix(in srgb, var(--p-primary-500, #3b82f6) 12%, transparent);
    padding: 0.15rem 0.6rem;
    border-radius: 999px;
  }

  .bulk-tasks-list {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    max-height: 300px;
    overflow-y: auto;
    padding-right: 0.3rem;
  }

  .bulk-tasks-list::-webkit-scrollbar {
    width: 4px;
  }

  .bulk-tasks-list::-webkit-scrollbar-thumb {
    background: var(--p-surface-300, #cbd5e1);
    border-radius: 4px;
  }

  .bulk-task-card {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.7rem 0.9rem;
    border: 1.5px solid var(--p-surface-200, #e2e8f0);
    border-radius: 10px;
    background: var(--p-surface-0, #fff);
    cursor: pointer;
    transition:
      border-color 0.15s,
      background 0.15s,
      box-shadow 0.15s;
    user-select: none;
  }

  .bulk-task-card:hover {
    border-color: var(--p-primary-400, #60a5fa);
    background: color-mix(in srgb, var(--p-primary-500, #3b82f6) 4%, #fff);
    box-shadow: 0 2px 6px rgba(59, 130, 246, 0.1);
  }

  .bulk-task-card--selected {
    border-color: var(--p-primary-500, #3b82f6) !important;
    background: color-mix(in srgb, var(--p-primary-500, #3b82f6) 7%, #fff) !important;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15) !important;
  }

  .bulk-task-check {
    display: flex;
    align-items: center;
    padding-top: 3px;
    flex-shrink: 0;
  }

  .bulk-task-check input[type='checkbox'] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: var(--p-primary-500, #3b82f6);
    pointer-events: none;
  }

  .bulk-task-info {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    flex: 1;
    min-width: 0;
  }

  .bulk-task-top-row {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    flex-wrap: nowrap;
  }

  .bulk-task-seq {
    font-weight: 700;
    font-size: 0.75rem;
    color: var(--p-primary-500, #3b82f6);
    background: color-mix(in srgb, var(--p-primary-500, #3b82f6) 10%, transparent);
    padding: 0.1rem 0.4rem;
    border-radius: 4px;
    flex-shrink: 0;
    line-height: 1.4;
  }

  .bulk-task-summary {
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--p-text-color, #1f2937);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
  }

  .bulk-task-meta-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .bulk-task-meta-item {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--p-text-secondary-color, #6b7280);
    white-space: nowrap;
  }

  .bulk-task-meta-item i {
    font-size: 0.7rem;
    opacity: 0.8;
  }

  .bulk-task-badge-finished {
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    font-size: 0.68rem;
    font-weight: 600;
    color: #16a34a;
    background: color-mix(in srgb, #16a34a 10%, transparent);
    border: 1px solid color-mix(in srgb, #16a34a 25%, transparent);
    padding: 0.15rem 0.5rem;
    border-radius: 999px;
  }

  .bulk-tasks-empty {
    text-align: center;
    padding: 1.5rem 1rem;
    color: var(--p-text-secondary-color, #6b7280);
    font-size: 0.85rem;
  }
</style>
